import * as actions from "./Type";
import Instance from "../util/Instance";
import setToken from "../util/SetToken";
export const Create_Project = (data) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/newProject`,
        { ...data },
        config
      );

      dispatch({
        type: actions.PROJECT_CREATED,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
export const Create_Vella_Project = (data) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1//newProjectViella`,
        { ...data },
        config
      );
      dispatch({
        type: actions.PROJECT_VELLA_CREATED,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
export const Adding_Shuqa = (pid, data) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/newShuqa/${pid}`,
        { ...data },
        config
      );
      dispatch({
        type: actions.APARTMENT_CREATED,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
export const Get_Projects = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getprojectsRE`, config);
      if (res.data.status === true) {
        dispatch({
          type: actions.GET_PROJECTS,
          payload: res.data.data,
          project_status: true,
        });
      }
    } catch (error) {}
  };
};
export const Get_List_Projects = (projectid) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      let lang = localStorage.getItem("key_lang");
      const res = await Instance.get(
        `/api/v1/ViewShuqaTable/${projectid}?lang=${lang ? lang : "krd"}`,
        config
      );
      dispatch({
        type: actions.GET_LIST_PROJECTS,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
export const Update_Shuqa_PerMetr = (shuqaId, data) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.put(
        `/api/v1/UpdateShuqaOFProject/${shuqaId}`,
        { ...data },
        config
      );
      dispatch({
        type: actions.UPDATE_SHUQA,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
export const All_List_Rent_Property = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/getAvailablePropertyRentRE`,
        config
      );
      if (res.data.status === true) {
        dispatch({
          type: actions.GET_ALL_RENT_PROPERTY,
          payload: res.data.data,
          R_L_status: true,
        });
      }
    } catch (error) {}
  };
};
export const All_List_Sell_Property = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/getAvailablePropertysSellRE`,
        config
      );
      if (res.data.status === true) {
        dispatch({
          type: actions.GET_ALL_SELL_PROPERTY,
          payload: res.data.data,
          S_L_status: true,
        });
      }
    } catch (error) {}
  };
};

export const View_Project = (id) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getProject/${id}`, config);
      dispatch({
        type: actions.VIEW_PROJECTS,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
export const View_Bill_Project = (projectsupportID, index) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/getProjectSupportView/${projectsupportID}`,
        config
      );
      dispatch({
        type: actions.VIEW_PROJECT_BILLS,
        payload: res.data.data,
        obj: index,
      });
    } catch (error) {}
  };
};
export const Get_List_Project_Bills = (projectid) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/ListOfProjectSupportMini/${projectid}`,
        config
      );
      dispatch({
        type: actions.GET_PROJECT_BILLS,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
export const Get_Count_ShuqaByStatus = (projectId, status) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/getShuqaStatus/${projectId}?status=${status}`,
        config
      );
      dispatch({
        type: actions.COUNT_SHUQA_BYSTATUS,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const View_All_Sell = (id) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/getAvailableProperty/${id}`,
        config
      );
      dispatch({
        type: actions.VIEW_ALL_SELL,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const View_All_Rent = (id) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/getAvailableProperty/${id}`,
        config
      );
      dispatch({
        type: actions.VIEW_ALL_RENT,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const Delete_Shuqa_ = (shuqaId) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.delete(`/api/v1/deleteShuqa/${shuqaId}`, config);
      dispatch({
        type: actions.DELETE_SHUQA,
      });
    } catch (error) {}
  };
};

export const View_Detail_Each_Shuqa = (id, sid) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      let lang = localStorage.getItem("key_lang");
      const res = await Instance.get(
        `/api/v1/ViewShuqa/${id}?lang=${lang ? lang : "krd"}&sid=${sid}`,
        config
      );
      dispatch({
        type: actions.VIEW_DETAIL_EACH_SHUQA,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const View_Vella_Project = (id) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/ViewViella/${id}`, config);
      dispatch({
        type: actions.VIEW_VELLA_PROJECTS,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const Delete_Vella = (vellaid) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.delete(`/api/v1/deleteViella/${vellaid}`, config);
      dispatch({
        type: actions.DELETE_VELLA,
      });
    } catch (error) {}
  };
};

// Add Vella
export const Adding_Vellas = (pid, data) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/newViella/${pid}`,
        { ...data },
        config
      );
      dispatch({
        type: actions.VELLAS_CREATED,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const Update_Vella = (vellaID, data) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.put(
        `/api/v1/UpdateViellaOFProject/${vellaID}`,
        { ...data },
        config
      );
      dispatch({
        type: actions.UPDATE_VELLA,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const Delete_Project = (shuqaId) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.delete(`/api/v1/deleteProject/${shuqaId}`, config);
      dispatch({
        type: actions.DELETE_PROJECT,
      });
    } catch (error) {}
  };
};

export const Get_Bills_Projects = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getprojectsRE`, config);
      dispatch({
        type: actions.GET_BILLS_PROJECTS,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const Delete_Taed = (taedId) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.delete(`/api/v1/deleteProjectSupport/${taedId}`, config);
      dispatch({
        type: actions.DELETE_TAED,
      });
    } catch (error) {}
  };
};

export const Project_Sellects_Taed = (data) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/printArrayData`,
        { ...data },
        config
      );
      dispatch({
        type: actions.POST_SELECTS_BILLS,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const Cancel_Sold_Project = (shuqaid) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.delete(`/api/v1/CancleProjectSupport/${shuqaid}`, config);
      dispatch({ type: actions.CANCEL_BILL_PROJECT });
    } catch (error) {}
  };
};

// calculate ration and salary and  expenses for agent & realestate & branch

export const Get_FROMTO_RatioRealestate_Raport = (
  from,
  to,
  agentId,
  branchId
) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/exprep?from=${from}&to=${to}&agentId=${agentId}&branchId=${branchId}&salary=true`,
        config
      );
      dispatch({
        type: actions.RATIO_EXP_REALESTATE,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const Update_Project = (projectId, data) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.put(
        `/api/v1/UpdateProject/${projectId}`,
        { ...data },
        config
      );
      dispatch({
        type: actions.UPDATE_PROJECT,
        payload: res.data.data,
      });
    } catch (error) {
      alert("Cant Update");
    }
  };
};
